import { useTranslation } from "react-i18next";
import { Loader2 } from "lucide-react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "../../../../../../shared/components/dialog/Dialog";
import { Button } from "../../../../../../shared/components/button/Button";

const DeleteMetricDialog = ({
  metric,
  onCancel,
  isDeleting,
  onDeleteHandler,
}) => {
  const { t } = useTranslation();

  return (
    <Dialog open={metric !== null}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>
            {t("datasetsCentre.datasets.metrics.deleteTitle")}
          </DialogTitle>
          <DialogDescription>
            {t("datasetsCentre.datasets.metrics.deleteMessage")}
            {metric && (
              <div className="mt-2 p-2 bg-muted rounded text-sm">
                <strong>{t("datasetsCentre.common.code")}:</strong>{" "}
                {metric.code}
              </div>
            )}
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button variant="outline" onClick={onCancel} disabled={isDeleting}>
            {t("datasetsCentre.common.cancel")}
          </Button>
          <Button
            variant="destructive"
            onClick={() => metric && onDeleteHandler(metric.id)}
            disabled={isDeleting}
          >
            {isDeleting ? (
              <>
                <Loader2 className="w-4 h-4 mr-2 animate-spin" />
                {t("datasetsCentre.common.deleting")}
              </>
            ) : (
              t("datasetsCentre.datasets.metrics.deleteTitle")
            )}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default DeleteMetricDialog;
